import { QUERY_DELETE_DELETEBRAND, QUERY_GET_BRANDS, QUERY_GET_BRANDSPAG, QUERY_POST_CREATEBRAND, QUERY_PUT_EDITBRAND} from '../../fetch/constantQueries'
import { baseThunk, getUrl } from '../../fetch/basicThunk';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDelete, fetchPut } from '../../fetch/fetchConfig';

export const getBrands = baseThunk(`brands/getBrands`, QUERY_GET_BRANDS, "GET");
export const getBrandsPag = baseThunk(`brands/getBrandsPag`, QUERY_GET_BRANDSPAG, "GET");

export const createBrand = baseThunk("brand/create", QUERY_POST_CREATEBRAND, "POST");
export const deleteBrand = baseThunk("brand/delete", QUERY_DELETE_DELETEBRAND, "DELETE");
export const editBrand = baseThunk("brand/dupdate", QUERY_PUT_EDITBRAND, "PUT");
